/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React from "react";
import { styled } from "@mui/system";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

const StyledImportantInfo = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  padding: "1.5rem",
  borderRadius: "1rem",
  background: "rgba(253, 231, 232, 0.60)",
  gap: "0.5rem",
  [theme.breakpoints.up("sm")]: {
    gap: "1rem"
  },
  "& .noteIcon": {
    "& svg": {
      width: "1.33331rem",
      height: "1rem",
      [theme.breakpoints.up("sm")]: {
        width: "2.5rem",
        height: "1.875rem"
      }
    }
  },
  "& .noteHeading": {
    margin: 0,
    color: "#000",
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: "1.25rem",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "1.75rem"
    }
  },
  "& .noteDesc": {
    margin: 0,
    color: "#3B3A3A",
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: "1.25rem",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1rem"
    }
  }
}));

const StyledTitle = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
  "& .title": {
    fontSize: "1.75rem",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "2.25rem"
  },
  "& .titleDescription": {
    fontSize: "1rem",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "1.5rem",
    color: "var(--colour-text-secondary, #4D4D4D)"
  }
}));

export const ImportantNote = ({
  hideTitle = false,
  noteTitle = "",
  noteInfo = "",
  heading,
  description,
  className,
  customIcon,
  ...props
}) => {
  return (
    <>
      {!hideTitle && (
        <StyledTitle
          className={`${className} titleWrapper`}
          {...props}
          data-testid="ImportantNoteTitle"
        >
          <span className="title">{noteTitle}</span>
          <div className="titleDescription">{noteInfo}</div>
        </StyledTitle>
      )}
      <StyledImportantInfo className={className} {...props} data-testid="Importan_tNote">
        <div className="noteIcon">{customIcon ? customIcon : <ErrorOutlineOutlinedIcon />}</div>
        <div className="noteInfo">
          <h5 className="noteHeading">{heading}</h5>
          <p className="noteDesc">{description}</p>
        </div>
      </StyledImportantInfo>
    </>
  );
};
